import { useRef, useState } from "react";
import { CalendarClock } from "lucide-react";

const LONG_PRESS_MS = 500;
const TOOLTIP_DISMISS_MS = 1500;

const MobilePickupButton = ({ onClick }) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const longPressTimer = useRef(null);
  const longPressTriggered = useRef(false);

  const clearLongPressTimer = () => {
    if (longPressTimer.current) {
      clearTimeout(longPressTimer.current);
      longPressTimer.current = null;
    }
  };

  const showTooltip = () => setTooltipVisible(true);
  const hideTooltip = () => setTooltipVisible(false);

  const handleTouchStart = () => {
    longPressTriggered.current = false;
    clearLongPressTimer();
    longPressTimer.current = setTimeout(() => {
      longPressTriggered.current = true;
      showTooltip();
    }, LONG_PRESS_MS);
  };

  const handleTouchEnd = () => {
    clearLongPressTimer();
    if (longPressTriggered.current) {
      setTimeout(hideTooltip, TOOLTIP_DISMISS_MS);
    }
  };

  const handleClick = (event) => {
    if (longPressTriggered.current) {
      event.preventDefault();
      longPressTriggered.current = false;
      return;
    }
    onClick?.(event);
  };

  return (
    <button
      type="button"
      className={`header-pickup-btn${tooltipVisible ? " tooltip-visible" : ""}`}
      onClick={handleClick}
      aria-label="Schedule Pickup"
      data-tooltip="Schedule Pickup"
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      onFocus={showTooltip}
      onBlur={hideTooltip}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchCancel={handleTouchEnd}
    >
      <CalendarClock size={16} strokeWidth={2} aria-hidden="true" />
      <span className="header-pickup-btn__label">Pickup</span>
    </button>
  );
};

export default MobilePickupButton;
